import type { Role } from '@alexiarest/shared';

/**
 * Que ve cada rol en la web. La API es quien cierra de verdad (403); esto
 * solo evita ensenyar puertas cerradas y decide a donde se lleva a cada uno.
 *
 * - `staff` (encargado, 21 ago 2026): sin P&L ni asistente; trabaja en Ingresos.
 * - `kitchen` (cocina, 7 sep 2026): solo la seccion Costeo; trabaja en Recetas.
 */
type Rol = Role | string | undefined;

/** ¿No ve la cuenta de resultados (portada, analisis, resultados, objetivos, impuestos, asistente)? */
export const sinPnl = (role: Rol): boolean => role === 'staff' || role === 'kitchen';

/** ¿Solo ve Costeo (tampoco ventas, gastos, tesoreria ni inversiones)? */
export const soloCosteo = (role: Rol): boolean => role === 'kitchen';

/** Pantalla de trabajo de cada rol: a donde se le lleva si pisa una puerta cerrada. */
export function portadaDe(role: Rol): string {
  if (role === 'kitchen') return '/recetas';
  if (role === 'staff') return '/ingresos';
  return '/';
}
